import { observer } from 'mobx-react';
import { FormFieldLine } from '../../../../../../components/form-field-line/form-field-line';
import { Input } from '../../../../../../components/inputs/input/input';
import { IValidationGroup } from '../../../../../../hooks/validation-group/validation-group-hook';
import BrightpearlOauthCredentialsStore from "../../../stores/credentials/brightpearl-credentials-store";

interface IIntegrationProps {
    credentialsStore: BrightpearlOauthCredentialsStore,
    vGroup: IValidationGroup,
}

const BrightpearlCredentials: React.FC<IIntegrationProps> = observer(({credentialsStore, vGroup}) => {
    return (
        <>
            <FormFieldLine label='Account ID' required key='account_id' note='Your account ID'>
                <Input
                    value={credentialsStore.account_id}
                    onChange={v => credentialsStore.account_id = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine label='Refund method code' required key='refund_method_code' note='Can be found in Brightpearl Dashboard => Accounting => List bank accounts => Choose needed => Edit and copy 4 digit code'>
                <Input
                    value={credentialsStore.refund_method_code}
                    onChange={v => credentialsStore.refund_method_code = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine label='New Sales Credit status ID' key='new_sales_credit_status_id' note='The ID of the status you wish to assign to the Sales Credit. If no status ID is specified then the configured default is used.'>
                <Input
                    value={credentialsStore.new_sales_credit_status_id}
                    onChange={v => credentialsStore.new_sales_credit_status_id = v}
                    validationGroup={vGroup}
                />
            </FormFieldLine>
            <FormFieldLine label='New Sales Credit channel ID' key='new_sales_credit_channel_name' note='The name of the channel of newly created Sales Channel.'>
                <Input
                    value={credentialsStore.newSalesCreditChannelName}
                    onChange={v => credentialsStore.newSalesCreditChannelName = v}
                    validationGroup={vGroup}
                />
            </FormFieldLine>
            <FormFieldLine label='Customer reference prefix' key='external_reference_prefix' note='Prefix to align to RMA number as customer reference'>
                <Input
                    value={credentialsStore.external_reference_prefix}
                    onChange={v => credentialsStore.external_reference_prefix = v}
                    validationGroup={vGroup}
                />
            </FormFieldLine>
        </>
    )
});

export default BrightpearlCredentials;
